import { jsx as r, jsxs as y, Fragment as E } from "react/jsx-runtime";
import T from "debounce";
import { forwardRef as k, useMemo as C, useEffect as o } from "react";
import { ToggleIcon as d } from "./ToggleIcon.js";
import { useSearchState as I } from "./useSearchState.js";
import { useChangeEffect as M } from "../../utils/hooks/useChangeEffect.js";
import { Input as j } from "../Input/Input.js";
import { LoadingSign as w } from "../../foundations/icons/LoadingSign/index.js";
import { Search as z } from "../../foundations/icons/Search.js";
import { Quote as D } from "../../foundations/icons/Quote.js";
import { CaseSensitive as F } from "../../foundations/icons/CaseSensitive.js";
const K = k(
  ({
    loading: n = !1,
    toggleCaseSensitive: g = !1,
    toggleExactMatch: p = !1,
    onValueChange: h,
    onKeyDown: v,
    caseSensitive: l = !1,
    exactMatch: c = !1,
    value: f = "",
    debounceTime: i = 300,
    onChange: S,
    ...u
  }, x) => {
    const [s, a] = I({ initialValue: f, initialCaseSensitive: l, initialExactMatch: c }), t = C(
      () => T((e, m) => {
        h?.(e, m);
      }, i),
      [h, i]
    );
    return o(() => {
      a.setValue({ value: f });
    }, [a, f]), o(() => {
      a.setCaseSensitive({ value: l });
    }, [a, l]), o(() => {
      a.setExactMatch({ value: c });
    }, [a, c]), M(() => {
      const { value: e, flush: m, ...b } = s;
      t(e, b), m && t.flush();
    }, [s, t]), o(
      // This effect just clears debounce buffer in case of unmount
      () => () => {
        t.clear();
      },
      [t]
    ), /* @__PURE__ */ r(
      j,
      {
        ref: x,
        placeholder: "Search...",
        prefix: n ? /* @__PURE__ */ r(w, { size: "20px" }) : /* @__PURE__ */ r(z, { size: "20px" }),
        clearable: !0,
        value: s.value,
        onChange: (e) => {
          a.setValue({ value: e.currentTarget.value }), S?.(e);
        },
        onKeyDown: (e) => {
          v?.(e), e.isDefaultPrevented() || (e.key === "Enter" && t.flush(), e.key === "Escape" && a.setValue({ value: "", flush: !0 }));
        },
        role: "searchbox",
        "aria-busy": n ? "true" : "false",
        suffix: /* @__PURE__ */ y(E, { children: [
          p ? /* @__PURE__ */ r(
            d,
            {
              label: "Toggle Exact Match",
              checked: s.exactMatch,
              disabled: u.disabled,
              onToggle: a.toggleExactMatch,
              children: /* @__PURE__ */ r(D, {})
            }
          ) : null,
          g ? /* @__PURE__ */ r(
            d,
            {
              label: "Toggle Case Sensitive",
              checked: s.caseSensitive,
              disabled: u.disabled,
              onToggle: a.toggleCaseSensitive,
              children: /* @__PURE__ */ r(F, {})
            }
          ) : null
        ] }),
        ...u
      }
    );
  }
);
K.displayName = "SearchInput";
export {
  K as SearchInput
};
//# sourceMappingURL=SearchInput.js.map
